/** FAQ copy for SEO + UX, student vs school intent */

export const faqStudent = [
  {
    q: 'What is Career DNA and how is it different from a regular career assessment?',
    a: 'Career DNA is a structured 7-trait framework that looks at how you think, work, and decide, not just marks or interests. It is combined with AI and expert logic so your report feels personal, not generic.',
  },
  {
    q: 'How long does the assessment take?',
    a: 'Most students finish in about 8–10 minutes. You get a clear, easy-to-read PDF report you can discuss with parents or counselors.',
  },
  {
    q: 'Is this only for science or commerce students?',
    a: 'No. The framework covers traditional and modern paths, design, tech, business, creative fields, and more, so your options are not limited to a few “popular” careers.',
  },
  {
    q: 'Will my data be private?',
    a: 'We take privacy seriously. Your details are used to generate your report and follow up only as you allow. Read our Privacy Policy for full details on collection, use, and your choices.',
  },
  {
    q: 'How does AI help in my report?',
    a: 'AI helps map your answers to patterns in the Career DNA model and surface insights in plain language. It does not replace human judgment, experts shape the framework and optional sessions add depth.',
  },
  {
    q: 'Can parents see my results?',
    a: 'Your PDF is yours to share. Many students review it with parents or teachers, we encourage an open conversation when you are ready.',
  },
  {
    q: 'What if I disagree with my report?',
    a: 'The report is a structured reflection, not a verdict. Use it to explore options, talk to a counsellor, and combine it with your own research and interests.',
  },
  {
    q: 'Do I have to pay for counselling?',
    a: 'The assessment and report path can stand alone. One-on-one sessions are optional and priced separately when you want deeper guidance.',
  },
  {
    q: 'Which classes is this for?',
    a: 'The program is designed with Class 9–12 in mind, when stream and career decisions matter most, but the ideas apply whenever you are choosing your next step.',
  },
];

export const faqSchool = [
  {
    q: 'How does ChooseRightCareer fit into our existing guidance setup?',
    a: 'We provide a structured assessment + reporting layer that complements counsellors and teachers, scalable bulk assessments, consistent Career DNA reports, and optional expert sessions.',
  },
  {
    q: 'What classes and cohort sizes do you support?',
    a: 'Programs are designed for Class 9–12. We work with you on cohort size, timelines, and whether to run sessions grade-wise or school-wide.',
  },
  {
    q: 'What does a school partnership typically include?',
    a: 'A typical engagement includes onboarding, student access to the assessment, PDF reports, and optional workshops or expert-led sessions, tailored to your school’s needs.',
  },
  {
    q: 'How do we get started?',
    a: 'Book a demo through the school form. Our team will walk you through rollout options, timelines, and pricing bands for your context.',
  },
  {
    q: 'Is student data handled in line with school requirements?',
    a: 'We work with institutions to align on consent, access, and retention. Our Privacy Policy describes how information is processed; we can discuss DPA-style terms for formal partnerships.',
  },
  {
    q: 'Can we white-label or co-brand reports?',
    a: 'Co-branding and programme packaging depend on the partnership tier, ask during your demo for options that fit your brand guidelines.',
  },
  {
    q: 'What support do teachers and counsellors get?',
    a: 'We provide orientation materials, optional walkthroughs, and escalation paths so your staff can interpret reports consistently and refer students to experts when needed.',
  },
  {
    q: 'How are bulk assessments scheduled?',
    a: 'Together we define windows (e.g. career week, term-wise), access codes or roster uploads where applicable, and communication templates for parents.',
  },
];
